import { createSlice } from '@reduxjs/toolkit';

const passwordChangeForExchangeSlice = createSlice({
  name: 'passwordChangeForExchange',
  initialState: {
    userInfo: {},
    blockOtpRequest: false,
    auth: false,
    updatePwd: false,
    updatePwdError: false,
    incorrectOTPcount: 0,
    error: {
      fnmInput: '',
      otpMobile: '',
      currentPwd: '',
    },
  },
  reducers: {
    getAuthenticateFnm: () => {
    },
    getAuthenticateFnmSuccess: (state, { payload }) => {
      state.userInfo = payload;
      state.mphonNo = payload.mphonNo ? payload.mphonNo.split(',')[0] : null;
    },
    setAuthenticateFnmFail: (state, { payload: error }) => {
      state.error = {};
      if (error?.errorCode === 'EM606') state.error.userId = 'MB_M_FINDPWD_FNM_ID_NOT_MATCH';
      else state.error.userId = error?.errorCode;
    },
    initAuthenticateFnmFail: state => {
      state.error = {};
    },
    setRequestOtpState: (state, { payload }) => {
      state.blockOtpRequest = !payload;
    },
    getAuthenticateAuthNum: (state, { payload }) => {
      state.authnum = payload.authnum;
    },
    getAuthenticateAuthNumSuccess: (state, { payload }) => {
      state.auth = true;
      state.financial = payload.financial;
    },
    setAuthenticateAuthNumFail: (state, { payload }) => {
      state.error.otpMobile = payload;
      state.incorrectOTPcount += 1;
    },
    resetIncorrectOTPCount: state => {
      state.incorrectOTPcount = 0;
      state.error.otpMobile = '';
    },
    getAuthenticateCallPhone: () => {
    },
    getAuthenticateExternalMail: () => {
    },
    modifyAuthenticatePassword: state => {
      state.updatePwdError = false;
    },
    modifyPasswordWithCurrentPassword: state => {
      state.updatePwdError = false;
    },
    modifyAuthenticatePasswordSuccess: (state, { payload }) => {
      state.updatePwd = payload;
      state.updatePwdError = false;
    },
    modifyAuthenticatePasswordFail: state => {
      state.updatePwdError = true;
    },
    checkCurrentPassword: state => {
      state.error.currentPwd = '';
    },
    checkCurrentPasswordSuccess: state => {
      state.auth = true;
      state.error.currentPwd = '';
    },
    setCheckCurrentPasswordFail: state => {
      state.error.currentPwd = 'MB_M_NOT_MATCH_CURRENTPWD';
    },
    resetCheckCurrentPasswordError: state => {
      state.error.currentPwd = '';
    },
    resetAuthMethodState: state => {
      state.authnum = '';
      state.incorrectOTPcount = 0;
      state.error.otpMobile = '';
      state.error.currentPwd = '';
    },
  },
});
export const {
  getAuthenticateFnm,
  getAuthenticateFnmSuccess,
  setAuthenticateFnmFail,
  initAuthenticateFnmFail,
  getAuthenticateCallPhone,
  getAuthenticateExternalMail,
  setRequestOtpState,
  getAuthenticateAuthNum,
  getAuthenticateAuthNumSuccess,
  setAuthenticateAuthNumFail,
  resetIncorrectOTPCount,
  modifyAuthenticatePassword,
  modifyPasswordWithCurrentPassword,
  modifyAuthenticatePasswordSuccess,
  modifyAuthenticatePasswordFail,
  checkCurrentPassword,
  checkCurrentPasswordSuccess,
  setCheckCurrentPasswordFail,
  resetCheckCurrentPasswordError,
  resetAuthMethodState,
} = passwordChangeForExchangeSlice.actions;
export default passwordChangeForExchangeSlice.reducer;
